import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { completeLogin } from "../auth/pkce";
import { config } from "../config";
import { useAuth } from "../auth/auth";
import { ErrorBox, Loading } from "../components/ui";

export const Route = createFileRoute("/auth/callback")({ component: Callback });

function Callback() {
  const nav = useNavigate();
  const auth = useAuth();
  const [error, setError] = useState<unknown>(null);
  useEffect(() => {
    const c = config();
    completeLogin(c.cognito_domain, c.cognito_client_id, new URLSearchParams(window.location.search))
      .then(({ tokens, returnTo }) => {
        auth.setTokens(tokens);
        void nav({ to: returnTo as "/", replace: true });
      })
      .catch(setError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <div className="min-h-screen grid place-items-center">{error ? <div className="w-[420px]"><ErrorBox error={error} /></div> : <Loading />}</div>;
}
